import { IconWrapper } from '../runtime';
export default IconWrapper('ordered-list', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M7.73438 7.99976H14.25M7.73438 13.7498H14.25M7.73438 2.24976H14.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 6.54393V2.55806L1.93323 3.35986C1.71535 3.57375 1.36715 3.56865 1.1555 3.34847C0.943843 3.12829 0.94889 2.77641 1.16677 2.56253L2.40773 1.3443C2.94666 0.815244 3.85 1.20114 3.85 1.96042V6.54393C3.85 6.85089 3.60376 7.09973 3.3 7.09973C2.99624 7.09973 2.75 6.85089 2.75 6.54393Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.48322 9.42262C2.89154 9.10074 3.3868 9.10074 3.79512 9.42262C4.17772 9.72421 4.2876 10.2937 3.99918 10.6996C3.94353 10.7779 3.86619 10.8756 3.76813 10.9907C3.57234 11.2206 3.31315 11.4979 3.02459 11.7931C2.4486 12.3824 1.77805 13.0204 1.316 13.4526C0.758589 13.9741 1.13499 14.8997 1.9044 14.8997H4.63917C4.94292 14.8997 5.18917 14.6576 5.18917 14.359C5.18917 14.0604 4.94292 13.8183 4.63917 13.8183H2.51739C2.92192 13.4337 3.39325 12.9767 3.81772 12.5425C4.11365 12.2397 4.39246 11.9423 4.61155 11.685C4.72093 11.5565 4.82024 11.4325 4.9009 11.319C4.97566 11.2138 5.05752 11.086 5.10585 10.9558C5.42396 10.0988 5.26414 9.19444 4.48322 8.57886C3.67281 7.94002 2.60553 7.94002 1.79512 8.57886C1.20052 9.04756 1.10275 9.67695 1.08868 10.0629C1.07779 10.3613 1.31506 10.6119 1.61862 10.6226C1.92218 10.6333 2.17709 10.4001 2.18797 10.1016C2.19742 9.84243 2.25624 9.60154 2.48322 9.42262Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});